import React, {Component} from 'react';
import {connect} from 'react-redux';
import {API_URL, IMAGE_URL} from "../../config/Config";
import axios from "axios/index";
import {Row, Col, Alert, Button, Input, FormText} from "reactstrap";
import { ToastContainer, toast } from 'react-toastify';
import PageLoader from "../loader/PageLoader";
import BootstrapTable from 'react-bootstrap-table-next';
import SaveLoader from "./../loader/SaveLoader";
import axiosRetry from 'axios-retry';
axiosRetry(axios, { retries: 3 });

class MerchantGalleryUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loading1: false,
            files:{
                img1: '',
                img2: '',
                img3: '',
                img4: '',
                img5: '',
            },
            imagePreviewUrl:{
                pimg1: '',
                pimg2: '',
                pimg3: '',
                pimg4: '',
                pimg5: '',
            },
            errors: {},
            hasAlert:false,
            business_id:0,
            images:[]
        };
    }
    async componentDidMount(){
        let business_id = await this.props.id;
        let images = await this.props.images;

        if (business_id){
            this.setState({business_id, images});
        }
    }
    async handleChange(event) {
        event.preventDefault();
        let files = this.state.files;
        let imagePreviewUrl = this.state.imagePreviewUrl;
        let reader = new FileReader();
        let id = event.target.id;
        let file = event.target.files[0];
        reader.onloadend = () => {
            files[id] = file;
            imagePreviewUrl[`p${id}`] =  reader.result;
            this.setState({files, imagePreviewUrl});
        };
        console.log(this.state);
        await reader.readAsDataURL(file);
    }

    async handleSubmit(event) {
        event.preventDefault();
        const {img1,img2,img3,img4,img5} = this.state.files;
        const formData = new FormData();
        formData.append('img1', img1);
        formData.append('img2', img2);
        formData.append('img3', img3);
        formData.append('img4', img4);
        formData.append('img5', img5);

        this.setState({loading1:true});
        try {


            let response = await axios.post(`${API_URL}business-upload-gallery/${this.state.business_id}?api_token=${this.props.user.apiToken}`,formData);

            if (response.status < 200 || response.status > 300) {
                const error = new Error(response.statusText);
                error.response = response;
                console.log(error);
                toast.error("خطایی در هنگام ذخیره سازی اطلاعات رخ داد.",{
                    autoClose: 3000,
                    position: toast.POSITION.TOP_RIGHT,
                    rtl:true
                });
            }else{
                let images = response.data.data;
                // console.log(response.data);
                toast.success("اطلاعات با موفقیت ذخیره گردید.",{
                    autoClose: 3000,
                    position: toast.POSITION.TOP_RIGHT,
                    rtl:true
                });
                let files={
                    img1: '',
                    img2: '',
                    img3: '',
                    img4: '',
                    img5: '',
                };
                let imagePreviewUrl={
                    pimg1: '',
                    pimg2: '',
                    pimg3: '',
                    pimg4: '',
                    pimg5: '',
                };
                this.setState({images,files,imagePreviewUrl});
            }

        }catch (e) {
            let apiError = await e.response;

            if (apiError === undefined) {
                console.log(e);
            } else {
                // let statusText = await apiError.statusText;
                // let status = await apiError.status;
                let data = await apiError.data;
                let apiErrorText = await data.data;
                this.setState({apiErrorText});
            }
            this.setState({hasAlert:true});

        }
        console.log("done");
        this.setState({loading1: false});
        //redirect to edit file
    }


    render() {
        const {pimg1,pimg2,pimg3,pimg4,pimg5} = this.state.imagePreviewUrl;
        let imagePreview=(<div style={{display:"flex", justifyContent: "center", alignItems: 'center', background:'#999',width:160, height:90}}>No Image</div> );
        let imagePreview1 =imagePreview;
        let imagePreview2 =imagePreview;
        let imagePreview3 =imagePreview;
        let imagePreview4 =imagePreview;
        let imagePreview5 =imagePreview;
        if (pimg1) {
            imagePreview1 = (<img src={pimg1} alt='business cover' style={{width:160, height:90}}/>);
        }
        if (pimg2) {
            imagePreview2 = (<img src={pimg2} alt='business cover' style={{width:160, height:90}}/>);
        }
        if (pimg3) {
            imagePreview3 = (<img src={pimg3} alt='business cover' style={{width:160, height:90}}/>);
        }
        if (pimg4) {
            imagePreview4 = (<img src={pimg4} alt='business cover' style={{width:160, height:90}}/>);
        }
        if (pimg5) {
            imagePreview5 = (<img src={pimg5} alt='business cover' style={{width:160, height:90}}/>);
        }
        const {errors, loading} = this.state;

        function imageView(cell) {
            return  (<img src={IMAGE_URL+cell} alt='business cover' style={{width:50, height:30}}/>);
        }
       /* function actionBtns(cell, row, rowIndex) {
            return (
                <ButtonGroup>
                    <Button size="sm" color="danger" onClick={()=>alert(cell)} ><i className="fa fa-trash"/></Button>
                    <Button size="sm" color="warning" onClick={()=>alert(row)}><i className="fa fa-edit"/></Button>
                    <Button size="sm" color="primary" onClick={()=>alert(rowIndex)}><i className="fa fa-search"/></Button>
                </ButtonGroup>
            );
        }*/
       /* const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,
        };*/
        const columns = [{
            dataField: 'id',
            text: 'شناسه',
            align: 'center',
            headerAlign: 'center',
        }, {
            dataField: 'image_url',
            text: 'تصویر',
            formatter: imageView,
        }, {
            dataField: 'image_title',
            text: 'عنوان',
        }, {
            dataField: 'created_at',
            text: 'تاریخ بارگذاری',
        }/*, {
            dataField: 'id',
            text: 'ابزارها',
            formatter: actionBtns,
        }*/];

        return (
            <div className="pt-3">
                <Row>
                    <Col md="12">
                        {this.state.hasAlert?
                            <Alert color="danger">
                                خطایی در هنگام ثبت اطلاعات رخ داد.
                            </Alert>
                            :""}
                    </Col>
                </Row>
                {!loading ? <PageLoader type="bubbles" color="#4fbfa8"/>:
                    <form onSubmit={(e)=>this.handleSubmit(e)} >
                        <Row>
                            <Col md="3" sm="12">
                                <div className="imgPreview1 mt-4 p-1 border border-dark1" style={{display:'inline-block'}}>
                                    {imagePreview1}
                                </div>
                            </Col>
                            <Col md="9" sm="12" className="pt-1">
                                    <Input
                                        type="file"
                                        className={errors["img1"]?"form-control is-invalid":"form-control mt-5"}
                                        name="img1"
                                        id="img1"
                                        onChange={this.handleChange.bind(this)}
                                    />
                                    {errors["img1"]?<div className="invalid-feedback" >{errors["img1"]}</div>:""}
                                    <FormText color="muted">
                                        فرمت مجاز jpg، png و gif  و حجم کمتر از 1024 کیلوبایت می باشد.
                                    </FormText>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="3" sm="12">
                                <div className="imgPreview1 mt-4 p-1 border border-dark1" style={{display:'inline-block'}}>
                                    {imagePreview2}
                                </div>
                            </Col>
                            <Col md="9" sm="12" className="pt-1">
                                <Input
                                    type="file"
                                    className={errors["img2"]?"form-control is-invalid":"form-control mt-5"}
                                    name="img2"
                                    id="img2"
                                    onChange={this.handleChange.bind(this)}
                                />
                                {errors["img2"]?<div className="invalid-feedback" >{errors["img2"]}</div>:""}
                                <FormText color="muted">
                                    فرمت مجاز jpg، png و gif  و حجم کمتر از 1024 کیلوبایت می باشد.
                                </FormText>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="3" sm="12">
                                <div className="imgPreview1 mt-4 p-1 border border-dark1" style={{display:'inline-block'}}>
                                    {imagePreview3}
                                </div>
                            </Col>
                            <Col md="9" sm="12" className="pt-1">
                                <Input
                                    type="file"
                                    className={errors["img3"]?"form-control is-invalid":"form-control mt-5"}
                                    name="img3"
                                    id="img3"
                                    onChange={this.handleChange.bind(this)}
                                />
                                {errors["img3"]?<div className="invalid-feedback" >{errors["img3"]}</div>:""}
                                <FormText color="muted">
                                    فرمت مجاز jpg، png و gif  و حجم کمتر از 1024 کیلوبایت می باشد.
                                </FormText>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="3" sm="12">
                                <div className="imgPreview1 mt-4 p-1 border border-dark1" style={{display:'inline-block'}}>
                                    {imagePreview4}
                                </div>
                            </Col>
                            <Col md="9" sm="12" className="pt-1">
                                <Input
                                    type="file"
                                    className={errors["img4"]?"form-control is-invalid":"form-control mt-5"}
                                    name="img4"
                                    id="img4"
                                    onChange={this.handleChange.bind(this)}
                                />
                                {errors["img4"]?<div className="invalid-feedback" >{errors["img4"]}</div>:""}
                                <FormText color="muted">
                                    فرمت مجاز jpg، png و gif  و حجم کمتر از 1024 کیلوبایت می باشد.
                                </FormText>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="3" sm="12">
                                <div className="imgPreview1 mt-4 p-1 border border-dark1" style={{display:'inline-block'}}>
                                    {imagePreview5}
                                </div>
                            </Col>
                            <Col md="9" sm="12" className="pt-1">
                                <Input
                                    type="file"
                                    className={errors["img5"]?"form-control is-invalid":"form-control mt-5"}
                                    name="img5"
                                    id="img5"
                                    onChange={this.handleChange.bind(this)}
                                />
                                {errors["img5"]?<div className="invalid-feedback" >{errors["img5"]}</div>:""}
                                <FormText color="muted">
                                    فرمت مجاز jpg، png و gif  و حجم کمتر از 1024 کیلوبایت می باشد.
                                </FormText>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6" sm="12"/>
                            <Col md="6" sm="12">
                                <div className="text-center mt-5">
                                    <Button color="default" block onClick={this.handleSubmit.bind(this)} className="mb-4 mt-4">
                                        بارگذاری فایل ها<i className="fa fa-paper-plane-o white-text ml-1"></i>
                                    </Button>
                                </div>

                            </Col>
                        </Row>
                    </form>}

                    <Row className="mt-5 mb-5">
                        <Col md="12">
                            <BootstrapTable
                                classes="data-table"
                                keyField='id'
                                data={this.state.images}
                                columns={ columns }
                                bordered={ false }
                                noDataIndication="موردی یافت نشد."
                                // selectRow={ selectRow }
                            />
                        </Col>
                    </Row>
                {this.state.loading1 ? <SaveLoader type='spinningBubbles' color='#fff' height={document.body.clientHeight}/>:""}

                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};

export default connect(mapStateToProps, null)(MerchantGalleryUpdate);


// WEBPACK FOOTER //
// ./src/components/merchants/MerchantGalleryUpdate.js